/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  IsTraceabilityRequestsSortableByDueDateQueryResponse,
  IsTraceabilityRequestsSortableByDueDateQueryParams,
} from "../types/IsTraceabilityRequestsSortableByDueDate.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const isTraceabilityRequestsSortableByDueDateQueryKey = (
  params?: IsTraceabilityRequestsSortableByDueDateQueryParams
) =>
  [
    { url: "/v1/traceability-requests/sorts/due-date" },
    ...(params ? [params] : []),
  ] as const

export type IsTraceabilityRequestsSortableByDueDateQueryKey = ReturnType<
  typeof isTraceabilityRequestsSortableByDueDateQueryKey
>

/**
 * @summary Check if traceability requests are sortable by due date
 * {@link /v1/traceability-requests/sorts/due-date}
 */
export async function isTraceabilityRequestsSortableByDueDate(
  params?: IsTraceabilityRequestsSortableByDueDateQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    IsTraceabilityRequestsSortableByDueDateQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/traceability-requests/sorts/due-date`,
    params,
    ...requestConfig,
  })
  return res
}

export function isTraceabilityRequestsSortableByDueDateQueryOptions(
  params?: IsTraceabilityRequestsSortableByDueDateQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = isTraceabilityRequestsSortableByDueDateQueryKey(params)
  return queryOptions<
    ResponseConfig<IsTraceabilityRequestsSortableByDueDateQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<IsTraceabilityRequestsSortableByDueDateQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return isTraceabilityRequestsSortableByDueDate(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Check if traceability requests are sortable by due date
 * {@link /v1/traceability-requests/sorts/due-date}
 */
export function useIsTraceabilityRequestsSortableByDueDate<
  TData = ResponseConfig<IsTraceabilityRequestsSortableByDueDateQueryResponse>,
  TQueryData =
    ResponseConfig<IsTraceabilityRequestsSortableByDueDateQueryResponse>,
  TQueryKey extends QueryKey = IsTraceabilityRequestsSortableByDueDateQueryKey,
>(
  params?: IsTraceabilityRequestsSortableByDueDateQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<IsTraceabilityRequestsSortableByDueDateQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    isTraceabilityRequestsSortableByDueDateQueryKey(params)

  const query = useQuery(
    {
      ...isTraceabilityRequestsSortableByDueDateQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
